import React from 'react'

import Checkbox from './Input.check'
import Date from './Input.date'
import File from './Input.file'
import Multiple from './Input.multiple'
import Number from './Input.number'
import Select from './Input.select'
import Sizes from './Input.sizes'
import Suggestions from './Input.suggestions'
import Text from './Input.text'
import TextArea from './Input.textarea'
import Types from './Input.types'
import type { InputDateRef } from './Input.date/Input.date'

interface InputProps {
    noresize?: boolean
    onChange?: (e: any) => void
    size?: Sizes
    type: Types
    value?: any
    [k: string]: any
}

const Input = React.forwardRef(({ type, ...props }: InputProps, ref: React.ForwardedRef<HTMLElement> | InputDateRef): JSX.Element | null => {
    switch (type) {
        case Types.CHECK:
            return <Checkbox ref={ref} {...props} />
        case Types.DATE:
            return <Date ref={ref as InputDateRef} {...props} />
        case Types.FILE:
            return <File ref={ref} {...props} />
        case Types.MULTIPLE:
            return <Multiple ref={ref} {...props} />
        case Types.NUMBER:
            return <Number ref={ref} {...props} />
        case Types.SELECT:
            return <Select ref={ref} {...props} />
        case Types.TEXT:
            return <Text ref={ref} {...props} />
        case Types.TEXTAREA:
            return <TextArea ref={ref} {...props} />
        case Types.SUGGESTIONS:
            return <Suggestions ref={ref} {...props} />
        default:
            return null
    }
})

export default Input
